import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import React, {Component} from "react";

/**
 * purchase
 * 
 * onSaveClick(purchase)
 * onCancelClick()
 */

class EditPurchaseDialog extends Component {

    constructor(props) {
        super(props)
        this.state = {
            name: this.props.purchase.name,
        }
    }

    readyToSave() {
        if (this.state.name === this.props.purchase.name) {
            return false
        }
        if (this.state.name.length === 0) {
            return false
        }
        return true
    }

    render() {
        return <Dialog open fullWidth>
            <DialogTitle>
                Редактировать закупку
            </DialogTitle>
            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                <TextField 
                    value = {this.state.name}
                    label = "Название закупки"
                    margin = "normal"
                    onChange = {e => {
                        e.preventDefault()
                        this.setState({name: e.target.value})
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {!this.readyToSave()}
                    onClick={e => {
                        e.stopPropagation()
                        if (typeof this.props.onSaveClick === "function") {
                            let result = global.structuredClone(this.props.purchase)
                            result.name = this.state.name
                            this.props.onSaveClick(result)
                        }
                    }}
                >Сохранить</Button>
                <Button
                    onClick={e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default EditPurchaseDialog